module.exports = __webpack_public_path__ + "imgesssyaa/svg/hot-air-balloon.521f1af1.svg";